import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import type { Feature, Geometry } from 'geojson';

interface PopupDatePeriodProps {
  feature: Feature<Geometry, { valid_from?: string; valid_to?: string }>;
}

export function PopupDatePeriod({ feature }: PopupDatePeriodProps) {
  const from = feature.properties.valid_from;
  const to = feature.properties.valid_to;

  return to || from ? (
    <Typography
      sx={{
        mb: 1,
      }}
    >
      {from && !to ? 'Ab ' : null}
      {from ? dayjs(from).format('L') : null}

      {from && to ? ' – ' : null}

      {!from && to ? 'Bis ' : null}
      {to ? dayjs(to).format('L') : null}
    </Typography>
  ) : null;
}
